/**
 * Step 10: Avalista
 * Coleta informações sobre avalista (CONDICIONAL - só aparece se tem restrições)
 */

import React, { useState } from 'react';
import { StepContainer, ChoiceButtons, StepNavigation } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

const Step10_Revendedora: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState<Pick<FormData, 'avalist'>>({ avalist: data.avalist || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const options = [
    { label: 'Sim', value: 'Sim' },
    { label: 'Não', value: 'Não' },
  ];

  const handleSelectOption = (value: string) => {
    setLocalData({ avalist: value as 'Sim' | 'Não' | '' });
    setErrors({});
  };

  const handleNext = () => {
    if (!localData.avalist) {
      setErrors({ avalist: 'Selecione uma opção' });
      return;
    }

    updateFields(localData);
    onNext(localData,'step21_mae');
  };

  return (
    <StepContainer
      title=""
      description=""
    >
      <div className="mb-6">
        <p className='text-muted-foreground text-sm mb-4'>
         Aqui na X do Infinito, levamos muito a sério a confiança e o compromisso que existe entre a empresa e cada Embaixadora. Por isso, mesmo você tendo restrições, queremos entender se você está realmente disposta a seguir com responsabilidade nessa nova etapa..
        </p>
        <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mb-4">
          <p className="text-amber-900 text-sm">
            Você se compromete a manter os acertos em dia e a conduzir sua jornada na X com seriedade e comprometimento, mesmo diante dos desafios?
          </p>
        </div>
      </div>
      <div>
        <ChoiceButtons
          options={options}
          selected={localData.avalist}
          onSelect={handleSelectOption}
        />
        {errors.avalist && (
          <p className="text-red-600 text-sm mt-2">{errors.avalist}</p>
        )}
      </div>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step10_Revendedora;
